import axios from "axios";
import {
  ADD_MEDICAL_RECORD,
  FETCH_MEDICAL_RECORDS,
  FETCH_LEFT_MEDICAL_RECORDS,
  DELETE_MEDICAL_RECORDS,
  SHOW_MEDICAL_RECORD,
  ADD_AVATAR,
  ADD_MEDICATION,
  DELETE_MEDICATION,
  UPDATE_MEDICAL_RECORD,
  FETCH_CONTRACT_FROM_WOO_STORE,
  ATTACH_MR_AVATAR,
  GET_TOTAL_MR_COUNT,
  interceptor,
  UPDATE_PRINT_MRECORD,
  CREATE_WOO_PET,
  PDF_GENERATOR_STATUS_CHANGE,
  FETCH_DELETED_MEDICAL_RECORDS,
  RECOVER_MEDICL_RECORDS,
  FETCH_BREEDERS_DELIVERY,
  UPDATE_WOO_PAGE_STATUS,
  FIND_PET_BYID,
  FETCH_BREEDERS_DELIVERY_BY_BREEDER_ID,
  FETCH_WAYBILL_FOR_ALL_PETS,
  BOOST_WOO_STORE_PROFILE,
  DELETE_PUPPY_VIDEO,
  UPDATE_VIDEO_CALL_STATUS,
  UPDATE_PIN_TO_TOP_QUEUE,
  DELETE_PROFILE_IMAGE,
  GET_LEADS_AVAILABLE_PETS,
  FETCH_AVAILABLE_PUPPIES_TO_QUEUE,
  GET_AVAILABLE_PUPPIES_FROM_QUEUE,
  GET_PET_NAMES_FROM_OPENAI,
  GET_PET_PERSONALITY_DESCRIPTION_FROM_OPENAI,
  GET_PET_ZODIAC_PERSONALITY_DESCRIPTION_FROM_OPENAI,
  UPDATE_MEDICAL_RECORD_MULTIPLE_IDS,
  UPDATE_MULTIPLE_MEDICAL_RECORDS_CALL_STATUS,
  FETCH_MEDICAL_RECORDS_BY_AGE
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function fetchMedicalRecords() {
  return {
    type: FETCH_MEDICAL_RECORDS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}



export function fetchDeletedMedicalRecords() {
  return {
    type: FETCH_DELETED_MEDICAL_RECORDS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/deleted`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchLeftMedicalRecords() {
  return {
    type: FETCH_LEFT_MEDICAL_RECORDS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/getLeftMedicalRecords`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function addMedicalRecord(mr) {
  return {
    type: ADD_MEDICAL_RECORD,
    // payload: axios.get(`${process.env.API_URL}/contracts/getContracts`),
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/`, mr, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getDeletable(selected) {
  return {
    type: DELETE_MEDICAL_RECORDS,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/${selected}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function recoverMRecords(selected){
  return {
    type: RECOVER_MEDICL_RECORDS,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/recover/${selected}`,{},{
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getTotalMedicalRecordsCount() {
  return {
    type: GET_TOTAL_MR_COUNT,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/getTotalMedicalRecordsCount`,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function showMedicalRecord(id) {
  return {
    type: SHOW_MEDICAL_RECORD,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function attachAvatar(avtr) {
  return {
    type: ADD_AVATAR,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/attachAvatar`, avtr, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function addMedication(data) {
  return {
    type: ADD_MEDICATION,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/addMedication`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteMedication(id) {
  return {
    type: DELETE_MEDICATION,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/deleteMedication`, id, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateMedicalRecord(id, data) {
  return {
    type: UPDATE_MEDICAL_RECORD,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchContractFromWooStore(data) {
  return {
    type: FETCH_CONTRACT_FROM_WOO_STORE,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/updateBillingDetailsfromWooOrder`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function attachMRAvatar(id, data) {
  return {
    type: ATTACH_MR_AVATAR,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/attachAvatar/${id}`,
      data,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function updatePrintMRecord(id) {
  return {
    type: UPDATE_PRINT_MRECORD,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function createWooPet(id, notifySubscribers) {
  return {
    type: CREATE_WOO_PET,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/createWooPet/${id}/${notifySubscribers}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function pdfGeneratorStatus(status) {
  return {
    type: PDF_GENERATOR_STATUS_CHANGE,
    payload: status
  }
}

export function fetchBreederDeliveryRecords(sdate, edate) {
  return {
    type: FETCH_BREEDERS_DELIVERY,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/deliveries/${sdate}/${edate}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchBreederDeliveryRecordsByBreederId(id, sdate, edate) {
  return {
    type: FETCH_BREEDERS_DELIVERY_BY_BREEDER_ID,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/collar-inserts/${id}/${sdate}/${edate}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateWooPageStatus(id, data) {
  return {
    type: UPDATE_WOO_PAGE_STATUS,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/updateWooPageStatus/${id}`,
      data,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function findPetById(data) {
  return {
    type: FIND_PET_BYID,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/findPetById`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };

}

export function fetchWaybillsForAllPets(id, sdate, edate) {
  return {
    type: FETCH_WAYBILL_FOR_ALL_PETS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/waybill-for-all/${store.getState().petShopReducer.currentPetshop.id}/${id}/${sdate}/${edate}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function boostWooStoreProfile(id) {
  return {
    type: BOOST_WOO_STORE_PROFILE,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/boostWooStoreProfile/${id}`, {}, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function removePuppyVideo(data) {
  return {
    type: DELETE_PUPPY_VIDEO,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/video/remove`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateVideoCallStatus(id, data) {
  return {
    type: UPDATE_VIDEO_CALL_STATUS,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/videoCallStatus/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function petPinToTop(id,status) {
  return {
    type: UPDATE_PIN_TO_TOP_QUEUE,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/boostWooStoreProfile/pinToTop/${id}/${status}`,{},{
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteProfileImage(id,data) {
  return {
    type: DELETE_PROFILE_IMAGE,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/profileImage/deleteProfileImage/${id}`,data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getAvailablePets() {
  return {
    type: GET_LEADS_AVAILABLE_PETS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/leads/availablePets`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchAvailablePuppiesToQueue(data) {
  return {
    type: FETCH_AVAILABLE_PUPPIES_TO_QUEUE,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/shuffle/availablePuppies/manual`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getPetNamesSuggestion(data) {
  return {
    type: GET_PET_NAMES_FROM_OPENAI,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/openAi/getPuppyName`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getAvailablePuppiesFromQueue() {
  return {
    type: GET_AVAILABLE_PUPPIES_FROM_QUEUE,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/shuffle/available/puppyQueue/isInQueue`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getPetPersonalityDescription(data) {
  return {
    type: GET_PET_PERSONALITY_DESCRIPTION_FROM_OPENAI,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/openAi/getPuppyPersonalityDescription`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getPetZodiacPersonalityDescription(data) {
  return {
    type: GET_PET_ZODIAC_PERSONALITY_DESCRIPTION_FROM_OPENAI,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/openAi/zodiac/description`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateMedicalRecordMultipleRecordIds(data) {
  return {
    type: UPDATE_MEDICAL_RECORD_MULTIPLE_IDS,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/updateArrivalDate/multipleRecords`,data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateMultipleMedicalRecordsCallStatus(status) {
  return {
    type: UPDATE_MULTIPLE_MEDICAL_RECORDS_CALL_STATUS,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/global/call/statusChange/${status}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchMedicalRecordsByAge(selectedDate) {
  return {
    type: FETCH_MEDICAL_RECORDS_BY_AGE,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/available/filter/age/${selectedDate}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}